const indexItems = [
  { title: '顶流塌房全记录', count: '36篇', desc: '盘点近年顶流明星塌房事件始末', icon: 'ri-collapse-diagonal-line', color: 'text-primary-600 bg-primary-100' },
  { title: '恋情曝光合集', count: '28篇', desc: '网红明星恋情实锤与绯闻追踪', icon: 'ri-heart-pulse-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '综艺翻车集锦', count: '24篇', desc: '热门综艺节目中的尴尬与争议瞬间', icon: 'ri-emotion-unhappy-line', color: 'text-accent-600 bg-accent-100' },
  { title: '直播事故档案', count: '21篇', desc: '网红直播间里的名场面与爆雷时刻', icon: 'ri-live-line', color: 'text-primary-600 bg-primary-100' },
  { title: '合约纠纷揭秘', count: '19篇', desc: '明星艺人合约纠纷与解约内幕', icon: 'ri-file-text-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '选秀黑幕深扒', count: '17篇', desc: '选秀节目背后的暗箱操作揭秘', icon: 'ri-spy-line', color: 'text-accent-600 bg-accent-100' },
  { title: '代言风波追踪', count: '15篇', desc: '品牌代言翻车事件全盘点', icon: 'ri-advertisement-line', color: 'text-primary-600 bg-primary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">爆料专题</h2>
        <p className="text-sm text-foreground-500 mb-8">国产51精品入口吃瓜爆料分类专题，按主题快速找到你想看的瓜</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item, idx) => (
            <div key={idx} className="p-5 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group">
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} mb-3`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4).map((item, idx) => (
            <div key={idx + 4} className="p-5 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group">
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} mb-3`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}